import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useIntercom } from "react-use-intercom";

import { getBoxPreviewInstance } from "~/components/aiAssistant/BoxPreview";
import { getBoxBaseUrlsFromSearch } from "~/hooks";
import { DEFAULT_BOX_API_BASE_URL } from "~/utils/box";

const FILE_PREVIEW_CONTAINER = "preview-box-file";

const Preview = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { shutdown } = useIntercom();

  useEffect(() => {
    shutdown();
  }, []);

  const page = queryParams.get("page");
  const folderAccessToken = queryParams.get("folderAccessToken");
  const templateFolderAccessToken = queryParams.get(
    "templateFolderAccessToken",
  );
  const fileId = queryParams.get("fileId");

  // Unauthenticated page — the proxy flag travels in the URL.
  const boxApiBaseUrl =
    getBoxBaseUrlsFromSearch(location.search)?.baseUrl ??
    DEFAULT_BOX_API_BASE_URL;

  const [boxScriptLoaded, setBoxScriptLoaded] = useState(false);

  const boxPreviewRef = useRef(getBoxPreviewInstance());

  useEffect(() => {
    document
      .getElementsByClassName("intercom-lightweight-app")?.[0]
      ?.classList?.add("hidden");
    const boxScriptLoadedInterval = setInterval(() => {
      if (boxPreviewRef.current) {
        setBoxScriptLoaded(true);
        clearInterval(boxScriptLoadedInterval);
      } else boxPreviewRef.current = getBoxPreviewInstance();
    }, 500);
    return () => {
      clearInterval(boxScriptLoadedInterval);
    };
  }, []);

  useEffect(() => {
    if (fileId === null || !boxScriptLoaded) return;

    const BoxPreview = boxPreviewRef.current;

    if (fileId) {
      const tokens = [folderAccessToken, templateFolderAccessToken].filter(
        Boolean,
      ) as string[];

      const getValidToken = async () => {
        for (const token of tokens) {
          try {
            const res = await fetch(`${boxApiBaseUrl}/files/${fileId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (res.ok) return token;
          } catch {
            // network error, try next token
          }
        }
        return tokens[0]; // fallback to first if all fail
      };

      getValidToken().then((token) => {
        if (page)
          BoxPreview.addListener("load", () => {
            const pageContainer = document
              .querySelector(`.${FILE_PREVIEW_CONTAINER}`)
              .querySelector(`[data-page-number="${page}"]`);
            if (!pageContainer) return;
            pageContainer.scrollIntoView({ behavior: "smooth" });
          });

        BoxPreview.show(fileId, token, {
          // Box Preview wants the host without the `/2.0` API version suffix
          apiHost: boxApiBaseUrl.replace(/\/2\.0$/, ""),
          container: `.${FILE_PREVIEW_CONTAINER}`,
          header: "none",
          showDownload: true,
        });
      });
    } else {
      BoxPreview.removeAllListeners();
      BoxPreview.hide();
    }
  }, [
    page,
    fileId,
    folderAccessToken,
    templateFolderAccessToken,
    boxScriptLoaded,
    boxApiBaseUrl,
  ]);

  return (
    <div>
      <div
        className={`mobile-box-container container h-screen ${FILE_PREVIEW_CONTAINER} [&_.bp-container]:!w-screen`}
      />
    </div>
  );
};

export default Preview;
